import React from "react";
import UxUiData from "../jsonData/ux-ui.json";
import * as Wis from "../style/webbutv-details-style";
import { BokaMote } from "../style/bokaMote";
import JL from "../../assets/portraits/JL_portrait.jpg";

interface UxUiContent {
  id: string;
  UxUiInfoHeader: string;
  text1: string;
  text2: string | string[];
  text3?: string;
}

const typedUxUiData: UxUiContent[] = UxUiData;

export const UxUiInfo: React.FC = () => {
  return (
    <Wis.BuildWebbContainer>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          width: "90%",
          maxWidth: "900px",
          margin: "0 auto",
        }}
      >
        <Wis.BackArrow />
      </div>
      <Wis.BuildWebbIntroHead>
        Webbutveckling – UX / UI design
      </Wis.BuildWebbIntroHead>
      <Wis.BuildWebHeader>UX / UI Design</Wis.BuildWebHeader>
      <Wis.Underline />

      <Wis.TwoContainer>
        {typedUxUiData.slice(0, 2).map((content) => (
          <Wis.Section key={content.id}>
            <Wis.BuildWebHeading>{content.UxUiInfoHeader}</Wis.BuildWebHeading>
            <Wis.BuildWebParagraph>{content.text1}</Wis.BuildWebParagraph>
            <Wis.BuildWebParagraph>{content.text2}</Wis.BuildWebParagraph>
          </Wis.Section>
        ))}
      </Wis.TwoContainer>

      <Wis.FullWidthContainer>
        <Wis.Section>
          <Wis.BuildWebHeading>
            {typedUxUiData[2].UxUiInfoHeader}
          </Wis.BuildWebHeading>
          <Wis.BuildWebParagraph>
            {typedUxUiData[2].text1}
          </Wis.BuildWebParagraph>

          {Array.isArray(typedUxUiData[2].text2) ? (
            <Wis.StyledList>
              {typedUxUiData[2].text2.map((item, index) => {
                const [boldPart, ...rest] = item.split("–");
                return (
                  <Wis.StyledListItem key={index}>
                    <strong>{boldPart.trim()} –</strong> {rest.join("–").trim()}
                  </Wis.StyledListItem>
                );
              })}
            </Wis.StyledList>
          ) : (
            <Wis.BuildWebParagraph>
              {typedUxUiData[2].text2}
            </Wis.BuildWebParagraph>
          )}
          <Wis.BuildWebParagraph>
            {typedUxUiData[2].text3}
          </Wis.BuildWebParagraph>
        </Wis.Section>
      </Wis.FullWidthContainer>
      <BokaMote 
          name="Johanna" 
          img={JL} 
          text="Boka ett möte med {name}." 
          email="hello@antech.se"
          subject="Bokningsförfrågan: Möte med Johanna"
          body="Hej Johanna, Jag är intresserad av att veta mer om webbutveckling & UX samt UI och skulle gärna boka ett möte med dig."
      />
    </Wis.BuildWebbContainer>
  );
};
